export default function () {
  let domain = location.host.split(':')[0]
  const hostParts = domain.split('.')

  if (hostParts.length > 2) {
    hostParts[0] = ''
    domain = hostParts.join('.')
  }

  document.cookie = 'force_legacy=1;path=/;domain=' + domain
}
